"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsClientSyncEvent = exports.ConnectionStateChangeEvent = exports.WsDataBucketEvent = exports.WsConnectionState = exports.WsClientSyncControlChannel = exports.WsHousekeepingMessageMarker = exports.Internal_WsRpcHandshakeTokenAttribName = void 0;
exports.Internal_WsRpcHandshakeTokenAttribName = 'wsRpcHandshakeToken';
/**
 * Flag to indicate websocket-related housekeeping message and not topic/user data.
 */
exports.WsHousekeepingMessageMarker = '_$w_wsAux';
/**
 * Prefix for channel/topic used to send initial state. It does not correspond with a dataBucket, but is used during the
 *  connection & sync process.
 */
exports.WsClientSyncControlChannel = '_$w_wsClientSync_control';
var WsConnectionState;
(function (WsConnectionState) {
    WsConnectionState["AttemptingNow"] = "AttemptingNow";
    WsConnectionState["Connected"] = "Connected";
    WsConnectionState["Disconnected"] = "Disconnected";
})(WsConnectionState = exports.WsConnectionState || (exports.WsConnectionState = {}));
var WsDataBucketEvent;
(function (WsDataBucketEvent) {
    WsDataBucketEvent["DataBucketSyncAction"] = "DataBucketSyncAction";
    WsDataBucketEvent["JoinStatusChange"] = "JoinStatusChange";
    WsDataBucketEvent["StateChange"] = "StateChange";
    WsDataBucketEvent["DataBucketReady"] = "DataBucketReady";
})(WsDataBucketEvent = exports.WsDataBucketEvent || (exports.WsDataBucketEvent = {}));
exports.ConnectionStateChangeEvent = 'wsStateChange';
exports.WsClientSyncEvent = Object.assign(Object.assign({}, WsDataBucketEvent), { ConnectionStateChangeEvent: exports.ConnectionStateChangeEvent, 
    /**
     * ResponseTargetReceived support the case of a request being sent non-websockets (xhr request) with the actual response sent over
     *  websockets (rather than on the original http request, which responds quickly with an "ok" kind of thing.)
     * Mainly for the purpose of managing user feedback, eg working/loading/pending indicator.
     * requestUid is a randomish client-generated token that the server carries along and includes in the final response
     *  when present in the initial request. When present, it is emitted on the WsClientSync instance.
     */
    ResponseTargetReceived: 'ResponseTargetReceived' });
//# sourceMappingURL=websocket-constants.js.map